import { getLinkStatus } from '../../helpers/numbers/linkStatuses';
import { formatLinkingNumbers } from '../../helpers/numbers/functions';
import { CAMPAIGN_QUALIFICATION_STATUS } from '../../helpers/campaigns/constants';

const formatLinks = (numbersMap, campaign) => {
  return formatLinkingNumbers(Object.values(numbersMap)).map(number => {
    const linkedCampaignId = number.campaignId;
    const linkedBrandId = number.brandId;
    return {
      ...number,
      linkStatus: getLinkStatus(linkedCampaignId && { id: linkedCampaignId }, campaign && campaign.id),
      linked: { id: linkedCampaignId, brandId: linkedBrandId },
      campaignLinkingStatus: number.status === CAMPAIGN_QUALIFICATION_STATUS.UNLINKED.value ? '' : number.status,
    };
  });
};

export default {
  numbers({ numbersMap }, getters , rootState) {
    const numbers = Object.values(numbersMap);

    if (!numbers.length) return numbers;

    return formatLinks(numbersMap, rootState.campaigns.campaign);
  },

  fetchingNumbers({fetchingNumbers}) {
    return fetchingNumbers
  },
};
